/*
 * SSOT for TRT Plus published methodology papers on Zenodo.
 * Pure JS (no JSX / imports) so Node-side build scripts can read it.
 *
 * Author: Nathan Southern (ORCID 0009-0007-4349-9154)
 * Community: https://zenodo.org/communities/trtplus-research
 */

export const METHODOLOGY_AUTHOR = {
    name: "Nathan Southern",
    orcid: "0009-0007-4349-9154",
    orcidUrl: "https://orcid.org/0009-0007-4349-9154",
    affiliation: "TRT Plus, Gold Coast, Australia",
};

export const METHODOLOGY_COMMUNITY_URL =
    "https://zenodo.org/communities/trtplus-research";

// Each paper is addressable by `slug` (used to attach papers to blog posts
// and engine formula cards). `note` is the technical-note number used in
// the citation format.
export const METHODOLOGY_PAPERS = [
    {
        slug: "overall-score",
        note: 1,
        shortTitle: "The TRT Plus Overall Score",
        title:
            "The TRT Plus Overall Score: A Deterministic Piecewise-Linear Biomarker Composite for Men on Testosterone Therapy",
        doi: "10.5281/zenodo.23005344",
        url: "https://doi.org/10.5281/zenodo.23005344",
    },
    {
        slug: "cascade",
        note: 2,
        shortTitle: "Cardio-Metabolic Cascade",
        title:
            "A Cardio-Metabolic Cascade for Personalised Haematocrit Tolerance and Dynamic Testosterone Ranges",
        doi: "10.5281/zenodo.23005442",
        url: "https://doi.org/10.5281/zenodo.23005442",
    },
    {
        slug: "androgen-load",
        note: 3,
        shortTitle: "Androgen:Estrogen Asymmetric Load",
        title:
            "An Asymmetric DHT-Weighted Androgen Load and Androgen:Estrogen Ratio",
        doi: "10.5281/zenodo.23005614",
        url: "https://doi.org/10.5281/zenodo.23005614",
    },
    {
        slug: "cream",
        note: 4,
        shortTitle: "Transdermal Cream Absorption",
        title:
            "A Site-Specific Saturable Absorption Model for Transdermal Testosterone Cream",
        doi: "10.5281/zenodo.23005645",
        url: "https://doi.org/10.5281/zenodo.23005645",
    },
    {
        slug: "dose-response",
        note: 5,
        shortTitle: "Protocol-Normalized Dose Response",
        title:
            "Protocol-Normalized Testosterone Dose Response: A Six-Tier Responder Classification from a Single Blood Draw",
        doi: "10.5281/zenodo.23029238",
        url: "https://doi.org/10.5281/zenodo.23029238",
    },
];

export function getPaperBySlug(slug) {
    return METHODOLOGY_PAPERS.find((p) => p.slug === slug);
}
